<script context="module">
    import { env } from '../Environment.svelte';

    export async function fetchPaymentURL(store) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url + 'WSVeL/webservices/izzi/mit';
        var headers = new Headers();
        var rpt =
            store.requestedAddress.addressRPT == null ||
            store.requestedAddress.addressRPT == undefined ||
            store.requestedAddress.addressRPT == ''
                ? '000'
                : store.requestedAddress.addressRPT;
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);
        headers.append('x-access-origin', 'IZZI');
        headers.append('x-access-channel', 'PORTALVL');
        headers.append('rpt', rpt);

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                plataforma: 'PORTALVL',
                canal: 'IZZI',
                rpt: rpt,
                monto: store.requestedServices.total,
                cuenta: store.purchaseStatus.accountNumber,
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Error al consumir el servicio webpayplus');
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function fetchPaymentStatus(store) {
        var PURCHASE_GET_PROCESS =
            env[env.stage].api.url + 'WSVeL/webservices/izzi/verif_pago';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);
        headers.append('x-access-origin', 'IZZI');
        headers.append('x-access-channel', 'PORTALVL');

        let endpoint = PURCHASE_GET_PROCESS;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                referencia:
                    store.purchaseStatus.paymentType == 'PAYPAL'
                        ? store.purchaseStatus.paypalPaymentReference
                        : store.purchaseStatus.paymentReference,
                cuenta: store.purchaseStatus.accountNumber,
                paypal:
                    store.purchaseStatus.paymentType == 'PAYPAL' ? true : false,
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function updateRecurrentPayment(store) {
        var PURCHASE_UPDATE_PAYMENT =
            env[env.stage].api.url + 'WSVeL/webservices/izzi/recurrente';
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].api.key);
        headers.append('x-access-origin', 'IZZI');
        headers.append('x-access-channel', 'PORTALVL');

        let endpoint = PURCHASE_UPDATE_PAYMENT;
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                cuenta: store.purchaseStatus.accountNumber,
            }),
        };

        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function fetchPayPalPaymentScript(store) {
        var URL_PAYPAL_SCRIPT =
            env[env.stage].apiPayPal.url + env[env.stage].apiPayPal.script;
        var headers = new Headers();
        headers.append('platform', 'WEB_PA');
        headers.append('channel', 'IZZI-VL');
        headers.append('x-api-key', env[env.stage].apiPayPal.key);

        let endpoint = URL_PAYPAL_SCRIPT;
        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error(
                        'Error al consumir el servicio PayPalScript'
                    );
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function fetchPayPalPaymentStatus(store) {
        var URL_PAYPAL_PAYMENT_STATUS =
            env[env.stage].apiPayPal.url +
            env[env.stage].apiPayPal.paymentStatus +
            store.purchaseStatus.accountNumber +
            '?payment_reference=' +
            store.purchaseStatus.paypalPaymentReference;
        let endpoint = URL_PAYPAL_PAYMENT_STATUS;
        var headers = new Headers();
        headers.append('platform', 'WEB_PA');
        headers.append('channel', 'IZZI-VL');
        headers.append('x-api-key', env[env.stage].apiPayPal.key);
        let requestOptions = {
            method: 'GET',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error(
                        'Error al consumir el servicio fetchPayPalPaymentStatus'
                    );
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function fetchPayPalCaptureBA(store, token, ba_token) {
        var URL_PAYPAL_CAPTUREBA =
            env[env.stage].apiPayPal.url +
            env[env.stage].apiPayPal.captureBA +
            store.purchaseStatus.accountNumber;
        let endpoint = URL_PAYPAL_CAPTUREBA;
        var headers = new Headers();
        headers.append('platform', 'WEB_PA');
        headers.append('channel', 'IZZI-VL');
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].apiPayPal.key);
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
            body: JSON.stringify({
                token: token,
                ba_token: ba_token,
                cambioDomiciliacion: true,
            }),
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.json();
                    //throw new Error('Error al consumir el servicio fetchPayPalCaptureBA');
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function fetchPayPalCancelBA(store, token, ba_token) {
        var URL_PAYPAL_CANCELBA =
            env[env.stage].apiPayPal.url +
            env[env.stage].apiPayPal.cancelBA +
            store.purchaseStatus.accountNumber;
        let endpoint = URL_PAYPAL_CANCELBA;
        var headers = new Headers();
        headers.append('platform', 'WEB_PA');
        headers.append('channel', 'IZZI-VL');
        headers.append('Content-Type', 'application/json');
        headers.append('x-api-key', env[env.stage].apiPayPal.key);
        let requestOptions = {
            method: 'POST',
            headers: headers,
            redirect: 'follow',
        };
        const resp = fetch(endpoint, requestOptions)
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    return response.json();
                    //throw new Error('Error al consumir el servicio fetchPayPalCaptureBA');
                }
            })
            .then((result) => {
                return result;
            });
        return await resp;
    }

    export async function getPayPalURLCreateOrder(store) {
        var URL_PAYPAL_CREATEORDER =
            env[env.stage].apiPayPal.url + env[env.stage].apiPayPal.createOrder;
        return URL_PAYPAL_CREATEORDER;
    }

    export async function getPayPalURLCaptureOrder(store) {
        var URL_PAYPAL_CAPTUREORDER =
            env[env.stage].apiPayPal.url +
            env[env.stage].apiPayPal.captureOrder;
        return URL_PAYPAL_CAPTUREORDER;
    }

    export async function getPayPalURLCancelOrder(store) {
        var URL_PAYPAL_CANCELORDER =
            env[env.stage].apiPayPal.url + env[env.stage].apiPayPal.cancelOrder;
        return URL_PAYPAL_CANCELORDER;
    }

    export async function getPayPalChannel(store) {
        var PAYPAL_CHANNEL = env[env.stage].apiPayPal.channel;
        return PAYPAL_CHANNEL;
    }

    export async function getPayPalPlatform(store) {
        var PAYPAL_PLATFORM = env[env.stage].apiPayPal.platform;
        return PAYPAL_PLATFORM;
    }
</script>
